export default "__VITE_ASSET__de91bc7a__"